import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getServices = () => client.get("/services").then((r) => r.data);
export const getPublications = () => client.get("/publications").then((r) => r.data);
export const getTestimonials = () => client.get("/testimonials").then((r) => r.data);
export const getBlog = () => client.get("/blog").then((r) => r.data);
export const getBlogPost = (slug) => client.get(`/blog/${slug}`).then((r) => r.data);
export const getConfig = () => client.get("/config").then((r) => r.data);
export const getSlots = (date) => client.get(`/bookings/slots`, { params: { date } }).then((r) => r.data);
export const createContact = (payload) => client.post("/contact", payload).then((r) => r.data);
export const createBooking = (payload) => client.post("/bookings", payload).then((r) => r.data);
export const verifyPayment = (payload) => client.post("/bookings/verify", payload).then((r) => r.data);

export default client;
